import React from 'react';

type TopbarProps = {
  title: string;
  subtitle: string;
};

export const Topbar: React.FC<TopbarProps> = ({ title, subtitle }) => (
  <header className="d-flex flex-wrap justify-content-between align-items-start mb-4">
    <div>
      <p className="text-uppercase text-muted small mb-1">Revenue Operations</p>
      <h1 className="h3 mb-1">{title}</h1>
      <p className="text-muted mb-0">{subtitle}</p>
    </div>
    <div className="d-flex gap-2">
      <button className="btn btn-outline-secondary">Share report</button>
      <button className="btn btn-primary">Add record</button>
    </div>
  </header>
);
